import { useNavigate } from 'react-router-dom';

import termsOfServiceMarkdown from '../../legal-documents/terms-of-service.md?raw';
import LegalDocumentPage from './legal-document-page';

const TermsOfUse = () => {
  const navigate = useNavigate();

  const handleBack = () => {
    navigate('/dashboard');
  };

  return <LegalDocumentPage markdown={termsOfServiceMarkdown} onBack={handleBack} />;
};

export default TermsOfUse;
